<template>
  <div v-if="canSeeTeam">
    <ListTeam v-if="hasTeam" />
    <NoPartner v-else />
  </div>
</template>

<script>
import NoPartner from "@/components/team/NoPartner.vue";
import ListTeam from "@/components/team/ListTeam.vue";
import PopupLinkPartner from "@/components/team/PopupLinkPartner.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    NoPartner,
    ListTeam,
    PopupLinkPartner,
  },
  computed: {
    ...mapGetters("team", ["hasTeam"]),
    ...mapGetters("profile", ["canSeeTeam", "canSeeBilling"]),
  },
  mounted() {
    if (this.canSeeTeam) {
      this.getTeam();
    }
    if (this.canSeeBilling) {
      this.getBalance();
    }
  },
  methods: {
    ...mapActions("team", ["getTeam"]),
    ...mapActions("billing", ["getBalance"]),
  },
};
</script>
